import { render, staticRenderFns } from "./sasaran.vue?vue&type=template&id=7e0dfd2c&"
import script from "./sasaran.vue?vue&type=script&lang=js&"
export * from "./sasaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports